<template>
  <div class="ui-flex ui-flex-pack-center login-panel">
    <div>
      <img src="../../static/img/big_logo.png" width="220px"  style="margin: 100px;" />
    </div>
    <div class="login-win" >
      <div class="input-container" >
        <div>
          <input v-model="mobile" class="input-user input1" placeholder="请输入手机号"/>
        </div>
        <div>
          <input type="password" v-model="pwd" class="input-password input1" placeholder="请输入密码"/>
        </div>
     
       <div class="input-bottom error" style="color: red!important;text-align: center;" >{{error}}</div>
        <div class="input-bottom" >
          <span class="left" v-on:click="orgetfpwd()" >忘记密码</span>
       <!--<router-link to="/register"><span class="right">注册</span></router-link>-->
      <!-- <router-link to="/register"><div class="right">注册</div></router-link>-->
           <span class="right" v-on:click="reg()" >注册</span>
                
        </div>
        <button class="button-login" v-on:click="login()" >
          登录
        </button>
      </div>
    </div>
   </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      mobile:"",
      pwd:"",
      error:""
    }
  },
  methods:{
  	go:function(url){
  		alert("jin")
  		this.$router.push(url);
  		
  		
  		
  	},
  	 
  	
  	
  	
orgetfpwd:function(){
      var self = this;
      if(this.mobile==''){
        self.error = "请输入手机号";
        return ;
      }
      this.$http.post('/ZYun/HttpService.do', {
        "serviceCode":"1007",
        "phoneNo":this.mobile
      })
      .then((response) => {
        if(response.data.respCode=="0000"){
           self.error = "重置密码成功请登录";
             const history = window.sessionStorage;
			       var uid = history.setItem("user","");
             this.$router.push("/register");
        }else{
          self.error = response.data.respMsg;
        }
      })
      .catch((response) =>{
        console.log(response);
      });
    },
    login:function(){
    	 var self = this;
    	var userSign =this.randomWord(false,8);
    	console.log("---------登录------------")
     
      if(this.mobile==''){
        self.error = "请输入手机号";
        return ;
      }
      if(this.pwd==''){
        self.error = "请输入密码";
        return ;
      }
      if(this.pwd.length < 6){
        self.error = "请输入密码少于6位";
        return ;
      }

      this.$http.post('/ZYun/HttpService.do', {
        "serviceCode":"1002",
        "userName":this.mobile,
        "userPwd":this.pwd,
        "loginType":"2",
        "jpId":this.mobile+userSign
      })
        .then((response) => {
            if(response.data.respCode=="0000"){
            	var md5pwd=$.md5(this.pwd);
            	store.set('childid', response.data.uId);
            	store.set("pwd",md5pwd)
             window.sessionStorage.setItem("user",response.data.uId)
              window.sessionStorage.setItem("mobile",this.mobile)
              window.sessionStorage.setItem("userSign",userSign);
              if(typeof(response.data.uParentId)!="undefined"){ 
               var arr=[];
							window.sessionStorage.setItem("parent", "1");
								
							   
						var qparams = {
									"serviceCode": "1029",
									'userId': response.data.uId
               }
								$.ajax({
									type: "post",
									url: "http://59.110.64.112:8080/ZYun/HttpService.do",
									async: true,
									data: JSON.stringify(qparams),
									dataType: 'json',
									success: function(dataa) {
							   $.each(dataa.authList, function(index, qusj) {
										switch(qusj.rId) {
												case "r001":
													store.set("sbkz" + response.data.uId, '1');
													break;
												case "r002":
													store.set("dtwz" + response.data.uId, '1');
													break;
												case "r005":
													store.set("xxjl" + response.data.uId, '1');
													break;
												case "r007":
													store.set("xgsbmc" + response.data.uId, '1');
													break;
												case "r008":
													store.set("ddjy" + response.data.uId, '1');
													break;
												case "r009":
													store.set("dkbj" + response.data.uId, '1');
													break;
												case "r010":
													store.set("tlbj" + response.data.uId, '1');
													break;
												default:
													break;
											}
										})

									}
								})
             setTimeout(function() {
								self.$router.push("/devicemanage");
							}, 2000)
          
              
              }else{
              	//父用户登陆
                window.sessionStorage.setItem("parent","0")
                 setTimeout(function() {
								 self.$router.push("/devicemanage");
							}, 2000)
              }
              
              
            }else{
              console.log(response.data.respMsg)
              self.error = response.data.respMsg;
            }
        })
        .catch((response) =>{
          console.log(response);
        });
    },
    reg:function(){
    	window.location="register.html";
   },
    randomWord :function(randomFlag, min, max){
        var str = "",
      
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 
        'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 
        'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
 
    // 随机产生
    if(randomFlag){
        range = Math.round(Math.random() * (max-min)) + min;
    }
    
    for(var i=0; i<range; i++){
      var pos = Math.round(Math.random() * (arr.length-1));
        str += arr[pos];
    }
    return str;
}
    
    
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../static/css/login.css">

</style>



// WEBPACK FOOTER //
// src/components/login.vue